import React from 'react';

export default function Unauthorized(props)
{
    return (
        <div>UNAUTH</div>
    )
}
